<template>
    <div class="vue-image-upload">
        <section v-if="!path" v-on:drop.prevent="dropFile" v-on:dragover.prevent="isActive = true" v-on:mouseleave="isActive = false">
            <div class="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md" v-bind:class="{ 'bg-indigo-100 border-indigo-600': isActive }">
                <div class="space-y-1 text-center">
                    <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                        <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    <div class="flex text-sm text-gray-600">
                        <label v-bind:for="name" class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                            <span>Upload image</span>
                            <input type="file" v-bind:id="name" v-bind:name="name" accept="image/*" v-on:change="selectFile" class="sr-only">
                        </label>
                        <p class="pl-1">or drag and drop</p>
                    </div>
                </div>
            </div>
        </section>
        <section v-else>
            <ul role="list" class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
                <li class="relative">
                    <div class="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 shadow p-4 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden">
                        <img v-bind:src="path" class="object-cover pointer-events-none group-hover:opacity-75" />
                    </div>
                    <p class="mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none" v-text="filename"></p>
                    <button type="button" v-on:click="deleteImage" class="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Delete image
                    </button>
                </li>
            </ul>
        </section>
    </div>
</template>

<script>
    export default {
        props: ['product', 'image'],
        data: function() {
            return {
                isActive: false,
                name: 'image',
                file: null,
                path: this.image,
                filename: null,
                filesize: null,
            };
        },
        mounted: function() {
            console.log('Component mounted');
        },
        computed: {
            isDisabled() {
              return this.file !== null;
            }
        },
        methods: {
            selectFile(event) {
                let selectedFiles = event.target.files;

                if (!selectedFiles) return;

                ([...selectedFiles]).forEach(file => {
                    this.file = file;
                });

                this.upload();
            },
            dropFile(event) {
                let droppedFiles = event.dataTransfer.files;

                if (!droppedFiles) return;

                ([...droppedFiles]).forEach(file => {
                    this.file = file;
                });

                this.upload();
            },
            removeFile(file){
                this.file = null;
            },
            removeImage() {
               this.path = null;
               this.filename = null;
               this.filesize = null;
            },
            deleteImage() {
                let formUrl = '/products/'+ this.product +'/images/delete';

                axios.post(formUrl, { uuid: null })
                    .then((response) => {
                       this.removeImage();
                   })
                   .catch((error) => {
                       console.log(error);
                   });
            },
            upload() {
                let formUrl = '/products/'+ this.product +'/images';
                let formData = new FormData();
                let formOptions = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };

                formData.append(this.name, this.file);

                axios.post(formUrl, formData, formOptions)
                    .then((response) => {
                       this.path = response.data.path;
                       this.filename = response.data.filename;
                       this.filesize = response.data.filesize;
                   })
                   .catch((error) => {
                       console.log(error);
                   });
            }
        }
    }
</script>
